export { default } from "ember-media-query/services/media";
